import { render, staticRenderFns } from "./ym-put.vue?vue&type=template&id=24593d0c&scoped=true&"
import script from "./ym-put.vue?vue&type=script&lang=js&"
export * from "./ym-put.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24593d0c",
  null
  
)

export default component.exports